// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"163":"b6f0084c","449":"e0052de9"}[chunkId] + ".css";
};